import reducers, { getDefaultState } from './reducers';

export { getDefaultState };
export default reducers;
